/**
 * Back to top.
 *
 * Collection pages show 24 products, and with a catalogue in the thousands
 * shoppers scroll a long way before deciding to change category. Returning to
 * the header by hand is the kind of small friction that adds up on mobile.
 *
 * Appears only once the visitor is well down the page, and is a real <button>
 * so it is reachable by keyboard and announced properly.
 */
(function () {
  'use strict';

  var SHOW_AFTER = 900;

  var button = document.querySelector('[data-back-to-top]');
  if (!button) return;

  var visible = false;
  var ticking = false;

  function update() {
    ticking = false;
    var shouldShow = window.scrollY > SHOW_AFTER;
    if (shouldShow === visible) return;
    visible = shouldShow;
    button.classList.toggle('is-visible', visible);
    // Hidden from assistive tech as well as sight when it is not offered.
    button.setAttribute('aria-hidden', visible ? 'false' : 'true');
    button.tabIndex = visible ? 0 : -1;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  button.addEventListener('click', function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });

    // Send focus back to the top of the document so keyboard users continue
    // from where the page now starts, rather than from a button off-screen.
    var main = document.getElementById('MainContent');
    if (main) {
      try { main.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
